import React from 'react';
import { Icon } from 'antd-mobile';

import { appMethod as app } from '@utils/app';
import { convertStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';

import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './CommunityGoodsListCustomComponent.less';

/**
 * type: community-goods-list
 * 组件：社区团购-社区团购活动列表
 */

  let stockChangeModule = {
    stockChange: function(a) {
      var b = a;
      if(a > 10000){
        b = parseInt(a/10000) + 'w';
      }
      return b;
    }
  }

export default class CommuntiyGoodsListCustomComponent extends React.Component {

  constructor(props) {
    super(props);
    const compindex = props.index;
    const pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    this.getGoodsIdxList(compindex);
    let _this = this;
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let locationInfo = app.globalData.locationInfo;
    let param = {};
    let data = {};
    data['eles[' + compindex + '].communityGoodsData'] = [];
    pageInstance.setData(data);
    if (customFeature.groupSetting && customFeature.groupSetting.height.indexOf('rem') < 0) {
      customFeature.margin = (parseInt(customFeature.margin) * 2.34 / 100) + 'rem';
      customFeature.imgWidth = (parseInt(customFeature.imgWidth) * 2.34 / 100) + 'rem';
      customFeature.imgHeight = (parseInt(customFeature.imgHeight) * 2.34 / 100) + 'rem';
      customFeature.groupSetting.height = (parseInt(customFeature.groupSetting.height) * 2.34 / 100)+ 'rem';
      customFeature.groupSetting['margin-top'] = (parseInt(customFeature.groupSetting['margin-top']) * 2.34 / 100) + 'rem';
      customFeature.groupSetting['address-font-size'] = (parseInt(customFeature.groupSetting['address-font-size']) * 2.34 / 100) + 'rem';
      customFeature.groupSetting['group-font-size'] = (parseInt(customFeature.groupSetting['group-font-size']) * 2.34 / 100) + 'rem';
      customFeature.timeLineSetting.height = (parseInt(customFeature.timeLineSetting.height) * 2.34 / 100) + 'rem';
      customFeature.timeLineSetting['margin-top'] = (parseInt(customFeature.timeLineSetting['margin-top']) * 2.34 / 100) + 'rem';
      customFeature.timeLineSetting['underline-height'] = (parseInt(customFeature.timeLineSetting['underline-height']) * 2.34 / 100) + 'rem';
      customFeature.timeLineSetting['font-size'] = (parseInt(customFeature.timeLineSetting['font-size']) * 2.34 / 100) + 'rem';
      customFeature.searchSetting.height = (parseInt(customFeature.searchSetting.height) * 2.34 / 100) + 'rem';
      customFeature.searchSetting['margin-top'] = (parseInt(customFeature.searchSetting['margin-top']) * 2.34 / 100) + 'rem';
      customFeature.goodsList['font-size'] = (parseInt(customFeature.goodsList['font-size']) * 2.34 / 100) + 'rem';
      customFeature.goodsList['height'] = (parseInt(customFeature.goodsList['height']) * 2.34 / 100) + 'rem';
      if (customFeature.vesselAutoheight == 1 || customFeature.vesselAutoheight == 2) {
        customFeature.height = 'auto';
      } else {
        customFeature.height = (parseInt(customFeature.height) * 2.34 / 100) + 'rem';
      }
      let newData = {};
      newData['eles[' + compindex + '].customFeature'] = customFeature;
      pageInstance.setData(newData);
    }
    if (customFeature.showTimeline) {
      let newData = {};
      let timeLineContent = customFeature.timeLineSetting.content;
      for (let i = 0; i < timeLineContent.length; i++) {
        if (timeLineContent[i].show) {
          newData['eles[' + compindex + '].status'] = i;
          break;
        }
      }
      pageInstance.setData(newData);
    } else {
      let newData = {};
      if (customFeature.startActive && !customFeature.finishActive) {
        newData['eles[' + compindex + '].status'] = 5
      } else if (!customFeature.startActive && customFeature.finishActive) {
        newData['eles[' + compindex + '].status'] = 6
      } else if (customFeature.startActive && customFeature.finishActive) {
        newData['eles[' + compindex + '].status'] = 7
      } else if (!customFeature.startActive && !customFeature.finishActive) {
        newData['eles[' + compindex + '].status'] = 0
      }
      pageInstance.setData(newData);
    }
    // 切换团长后不需要重新请求团长列表
    if (pageInstance.data.eles[compindex].leaderInfo) {
      _this.getCommunityGoodsList(compindex);
      return;
    }
    // 判断分享进来的团长可不可用
    if (app.globalData.communityUserToken) {
      this.checkGroupGoodsLeader(compindex, app.globalData.communityUserToken);
      return;
    }
    // 获取上一次团长
    app.getStorage({
      key: 'groupToken',
      complete: function (res) {
        if (res && res.data) {
          _this.checkGroupGoodsLeader(compindex, res.data);
        } else if (locationInfo.latitude) {
          _this.latitude = locationInfo.latitude;
          _this.longitude = locationInfo.longitude;
          _this.getGoodsGroupList(compindex, param);
        } else {
          app.getLocation({
            type: 'gcj02',
            success: function (res) {
              let latitude = res.latitude;
              let longitude = res.longitude;
              pageInstance.requestNum++;
              app.sendRequest({
                hideLoading: true,
                url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
                data: {
                  latitude: latitude,
                  longitude: longitude
                },
                success: function (res) {
                  app.setLocationInfo({
                    latitude: latitude,
                    longitude: longitude,
                    address: res.data.formatted_addresses.recommend,
                    info: res.data
                  });
                }
              });
              _this.latitude = latitude;
              _this.longitude = longitude;
              _this.getGoodsGroupList(compindex);
            },
            fail: function (res) {
              let newdata = {};
              if (res.errMsg === 'getLocation:fail auth deny' || res.errMsg === "getLocation:fail:auth denied") {
                newdata['eles[' + compindex + '].location_address'] = '已拒绝定位';
              } else {
                newdata['eles[' + compindex + '].location_address'] = '定位失败';
              }
              pageInstance.setData(newdata);
            }
          });
        }
      }
    })
  }

  // 根据经纬度获取团长
  getGoodsGroupList = (compindex) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetDistributorExtList',
      method: 'post',
      data: {
        latitude: this.latitude,
        longitude: this.longitude,
        is_audit: 1,
        filter_deleted: 1
      },
      success: function (res) {
        if (res.data.length) {
          let data = {};
          data['eles[' + compindex + '].leaderInfo'] = res.data[0];
          // 储存上一次的团长userToken
          app.setStorage({
            key: 'groupToken',
            data: res.data[0].user_token
          })
          pageInstance.setData(data);
        }
        _this.getCommunityGoodsList(compindex);
      }
    })
  }

  communityGoodsScrollFunc = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = typeof event == 'object' ? event.currentTarget.dataset.compindex : event;
    let compData = pageInstance.data.eles[compindex];
    let page = compData.page + 1;
    let newdata = {};
    if (compData.loading || !compData.is_more) {
      return;
    }
    newdata['eles[' + compindex + '].page'] = page;
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    pageInstance.setData(newdata);
    this.getCommunityGoodsList(compindex);
  }

  chengeCommunityGroup = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let token = pageInstance.data.eles[compindex].leaderInfo.user_token
    let router = app.returnSubPackageRouter("communityGroupSearchVillage");
    app.turnToPage(router + '?token=' + token + '&compindex=' + compindex);
  }

  toCommunityGoodsDetail = (e) => {
    let goodsId = e.currentTarget.dataset.goodsId;
    let groupId = e.currentTarget.dataset.groupId;
    let leader_token = e.currentTarget.dataset.leaderToken || '';
    let router = app.returnSubPackageRouter("commuGroupGoods") + `?goodsId=${goodsId}&group_id=${groupId}&leaderToken=${leader_token}`;
    app.turnToPage(router);
  }

  getCommunityGoodsList = (compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let compindexParam = pageInstance.data.eles[compindex];
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsList',
      method: 'post',
      data: {
        idx_arr: {
          idx: 'title',
          idx_value: compindexParam.idx_value
        },
        is_stock_gte_zero: compindexParam.customFeature.soldOut ? 1 : 0,
        status: compindexParam.status >= 0 ? compindexParam.status + 1 : -1,
        page_size: compindexParam.customFeature.loadingNum || 10,
        page: compindexParam.page || 1,
        leader_token: compindexParam.leaderInfo ? compindexParam.leaderInfo.user_token : ''
      },
      success: function (res) {
        let data = {};
        let goodsList = compindexParam.communityGoodsData || [];
        data['eles[' + compindex + '].communityGoodsData'] = [...goodsList, ...res.data];
        data['eles[' + compindex + '].is_more'] = res.is_more;
        data['eles[' + compindex + '].page'] = res.current_page;
        data['eles[' + compindex + '].loading'] = false;
        data['eles[' + compindex + '].loadingFail'] = false;
        pageInstance.setData(data);
      },
      fail: function () {
        let dataFail = {};
        dataFail['eles[' + compindex + '].loadingFail'] = true;
        dataFail['eles[' + compindex + '].loading'] = false;
        pageInstance.setData(dataFail);
      }
    })
  }

  getTimeLineGoods = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let newdata = {};
    let type = e.target.dataset.type;
    let compindex = e.currentTarget.dataset.compindex;
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      app.showModal({
        content: '暂无团长，无法搜索'
      })
      return;
    }
    newdata['eles[' + compindex + '].communityGoodsData'] = [];
    newdata['eles[' + compindex + '].status'] = type;
    newdata['eles[' + compindex + '].page'] = 1;
    newdata['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(newdata);
    this.getCommunityGoodsList(compindex);
  }

  searchGoodsList = (e) => {
    if (e.keyCode !== 13) {
      return;
    }
    let newdata = {};
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let value = e.target.value;
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      app.showModal({
        content: '暂无团长，无法搜索'
      })
      return;
    }
    newdata['eles[' + compindex + '].communityGoodsData'] = [];
    newdata['eles[' + compindex + '].idx_value'] = value;
    newdata['eles[' + compindex + '].page'] = 1;
    newdata['eles[' + compindex + '].is_more'] = 1;
    pageInstance.setData(newdata);
    this.getCommunityGoodsList(compindex);
  }

  hideGoodsDialog = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = e.currentTarget.dataset.compindex;
    let newData = {};
    newData['eles[' + compindex + '].showGoodsDetail'] = false;
    pageInstance.setData(newData);
  }

  addCommunityCart = (e) => {
    e.stopPropagation();
    let pageInstance = app.getAppCurrentPage();
    let id = e.currentTarget.dataset.id;
    let compindex = e.currentTarget.dataset.compindex;
    let compindexParam = pageInstance.data.eles[compindex];
    if (!pageInstance.data.eles[compindex].leaderInfo) {
      app.showModal({
        content: '暂无团长，无法加入购物车'
      })
      return;
    }
    app.sendRequest({
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsList',
      method: 'post',
      data: {
        leader_token: compindexParam.leaderInfo.user_token,
        goods_id: [id]
      },
      success: function (res) {
        let newData = {};
        let goods = res.data[0];
        let selectGoodsModelInfo;
        let defaultSelect, goodprice, goodstock, goodimgurl, virtual_price, goodId;
        let goodsModel = [];
        let selectModels = [];
        let selectText = '';
        if (goods.form_data.goods_model) {
          defaultSelect = goods.form_data.goods_model[0]
          goodprice = defaultSelect.price;
          goodstock = defaultSelect.stock;
          goodId = defaultSelect.id;
          goodimgurl = defaultSelect.img_url;
          virtual_price = defaultSelect.virtual_price;
        } else {
          goodprice = goods.price;
          goodstock = goods.stock;
          goodimgurl = goods.cover;
          virtual_price = goods.virtual_price;
        }
        for (let key in goods.form_data.model) {
          if (key) {
            let model = goods.form_data.model[key];
            goodsModel.push(model);
            selectModels.push(model.subModelId[0]);
            selectText += '“' + model.subModelName[0] + '” ';
          }
        }
        goods.model = goodsModel;
        selectGoodsModelInfo = {
          price: goodprice,
          stock: goodstock,
          buyCount: 1,
          models: selectModels,
          modelId: goodId || '',
          models_text: selectText,
          imgurl: goodimgurl,
          virtual_price: virtual_price
        }
        newData['eles[' + compindex + '].selectGoodsModelInfo'] = selectGoodsModelInfo;
        newData['eles[' + compindex + '].showGoodsDetail'] = true;
        newData['eles[' + compindex + '].goodsDetail'] = goods;
        pageInstance.setData(newData);
      }
    })
  }

  selectGoodsSubModel = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let dataset = event.target.dataset;
    let modelIndex = dataset.modelIndex;
    let submodelIndex = dataset.submodelIndex;
    let data = {};
    let selectModels = pageInstance.data.eles[compindex].selectGoodsModelInfo.models;
    let model = pageInstance.data.eles[compindex].goodsDetail.model;
    let text = '';
    selectModels[modelIndex] = model[modelIndex].subModelId[submodelIndex];
    for (let i = 0; i < selectModels.length; i++) {
      let selectSubModelId = model[i].subModelId;
      for (let j = 0; j < selectSubModelId.length; j++) {
        if (selectModels[i] == selectSubModelId[j]) {
          text += '“' + model[i].subModelName[j] + '” ';
        }
      }
    }
    data['eles[' + compindex + '].selectGoodsModelInfo.models'] = selectModels;
    data['eles[' + compindex + '].selectGoodsModelInfo.models_text'] = text;
    pageInstance.setData(data);
    this.resetSelectCountPrice(compindex);
  }

  resetSelectCountPrice = (compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let selectModelIds = pageInstance.data.eles[compindex].selectGoodsModelInfo.models.join(',');
    let modelItems = pageInstance.data.eles[compindex].goodsDetail.form_data.goods_model;
    let data = {};
    data['eles[' + compindex + '].selectGoodsModelInfo.buyCount'] = 1;
    for (let i = modelItems.length - 1; i >= 0; i--) {
      if (modelItems[i].model == selectModelIds) {
        data['eles[' + compindex + '].selectGoodsModelInfo.stock'] = modelItems[i].stock;
        data['eles[' + compindex + '].selectGoodsModelInfo.price'] = modelItems[i].price;
        data['eles[' + compindex + '].selectGoodsModelInfo.modelId'] = modelItems[i].id || '';
        data['eles[' + compindex + '].selectGoodsModelInfo.imgurl'] = modelItems[i].img_url || '';
        data['eles[' + compindex + '].selectGoodsModelInfo.virtual_price'] = modelItems[i].virtual_price
        break;
      }
    }
    pageInstance.setData(data);
  }

  inputBuyCount = (e) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    pageInstance.setData({
      ['eles[' + compindex + '].selectGoodsModelInfo.buyCount']: e.target.value
    })
  }

  clickGoodsMinusButton = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let count = pageInstance.data.eles[compindex].selectGoodsModelInfo.buyCount;
    if (count <= 1) {
      return;
    }
    pageInstance.setData({
      ['eles[' + compindex + '].selectGoodsModelInfo.buyCount']: count - 1
    });
  }

  clickGoodsPlusButton = (event) => {
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let selectGoodsModelInfo = pageInstance.data.eles[compindex].selectGoodsModelInfo;
    let count = selectGoodsModelInfo.buyCount;
    let stock = selectGoodsModelInfo.stock;
    if (count >= stock) {
      return;
    }
    pageInstance.setData({
      ['eles[' + compindex + '].selectGoodsModelInfo.buyCount']: count + 1
    });
  }

  sureAddToShoppingCart = (event) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    let compindex = event.currentTarget.dataset.compindex;
    let compindexParam = pageInstance.data.eles[compindex];
    let param = {
      goods_id: compindexParam.goodsDetail.id,
      model_id: compindexParam.selectGoodsModelInfo.modelId || '',
      num: compindexParam.selectGoodsModelInfo.buyCount,
      dis_group_id: compindexParam.goodsDetail.group_id,
      leader_token: compindexParam.leaderInfo.user_token
    };
    app.sendRequest({
      url: '/index.php?r=AppShop/addCart',
      data: param,
      success: function (res) {
        _this.hideGoodsDialog(event);
      }
    })
  }

  getGoodsIdxList = (compindex) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/GetAppDistributionGroupGoodsIdxList',
      success: function (res) {
        pageInstance.setData({
          ['eles[' + compindex + '].buyerIndex']: 0,
          ['eles[' + compindex + '].buyerInfoList']: res.data || []
        });
        if (res.data.length) {
          _this.cycleGoodsBuyerList(compindex);
        }
      }
    })
  }

  cycleGoodsBuyerList = (compindex) => {
    let pageInstance = app.getAppCurrentPage();
    let compindexParam = pageInstance.data.eles[compindex];
    if (compindexParam.buyerIndex < 0) {
      return;
    }
    setInterval(() => {
      let index = compindexParam.buyerIndex;
      let buyerInfoList = compindexParam.buyerInfoList
      index++;
      if (index == buyerInfoList.length - 1) {
        index = 0;
      }
      pageInstance.setData({
        ['eles[' + compindex + '].buyerIndex']: index
      });
    }, 8000)
  }

  // 判断团长可不可用
  checkGroupGoodsLeader = (compindex, userToken) => {
    let _this = this;
    let pageInstance = app.getAppCurrentPage();
    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppDistributionExt/CheckIsDistributorGroupLeaderInfo',
      data: {
        leader_token: userToken
      },
      success: function (res) {
        let newdata = {};
        if (!res.data.learder_info) {
          app.globalData.communityUserToken = '';
          app.removeStorage({
            key: 'groupToken',
            complete: function () {
              _this.init(compindex, pageInstance);
            }
          })
          return;
        }
        newdata['eles[' + compindex + '].leaderInfo'] = res.data.learder_info;
        pageInstance.setData(newdata);
        _this.getCommunityGoodsList(compindex);
      },
    })
  }

  render() {
    const data = this.props.data;

    // 样式数据处理
    const styleObj = convertStyleData(data.style);

    // 顶部搜索框
    const $searchWrap = () => {
      return <div className="search-box"
        style={{
          height: data.customFeature.searchSetting.height,
          marginTop: data.customFeature.searchSetting['margin-top']
        }}>
        <div className="search-input">
          <Icon size='xxs' type='search' color="#999"></Icon>
          <input type='text' placeholder='请输入搜索内容' onKeyDown={(e) => this.searchGoodsList(e)} data-compindex={this.props.index} />
        </div>
      </div>
    }

    // 头部内容
    const $headWrap = () => {
      return <div className="community-head"
        style={{
          height: data.customFeature.groupSetting.height, marginTop: data.customFeature.groupSetting['margin-top'],
          background: data.customFeature.groupSetting.background
        }}>
        <img className="colone-avatar"
          src={(data.leaderInfo && data.leaderInfo.logo) || 'https://cdn.jisuapp.cn/static/jisuapp_editor/images/new-zhichi-default.png'} />
        <div className='colone-detail-box'>
          <div className="colone-name"
            style={{
              color: data.customFeature.groupSetting['group-color'],
              fontSize: data.customFeature.groupSetting['group-font-size']
            }}>
            {(data.leaderInfo && data.leaderInfo.nick_name) ? (data.leaderInfo.nick_name + '-') : '暂无团长'}{(data.leaderInfo && data.leaderInfo.housing_estate) || ''}
          </div>
          <div className="colone-address"
            style={{
              color: data.customFeature.groupSetting['address-color'],
              fontSize: data.customFeature.groupSetting['address-font-size']
            }}>
            自提地址：{(data.leaderInfo && data.leaderInfo.address_detail) || "暂未设置"}
          </div>
        </div>
        {data.customFeature.groupSetting.changeCaptain &&
          <div className="change-captain"
            data-compindex={data.compindex}
            onClick={data.leaderInfo ? this.chengeCommunityGroup : this.isOpenCommunityGroup}
            style={{ color: data.customFeature.groupSetting['btn-color'], background: data.customFeature.groupSetting['btn-background'] }}>
            <span className='ico-moon icon-change'></span>{data.leaderInfo ? '切换团长' : '申请团长'}
          </div>
        }
        {!!(data.buyerInfoList && data.buyerInfoList.length) &&
          <div className='scroll-avatar-box'>
            <div className='community-buyer-scrollling'>
              <div className='scroll-avatar'>
                <img src='{{data.buyerInfoList[data.buyerIndex].buyer_info.logo}}' />
                <span className='scroll-name'>{data.buyerInfoList[data.buyerIndex].buyer_info.nickname}</span>下单成功了
              </div>
            </div>
          </div>
        }
      </div>
    }

    // 时间轴1
    const $timeLineOne = () => {
      return <div className="time-line-box"
        onClick={this.getTimeLineGoods}
        data-compindex={this.props.index}
        style={{
          background: data.customFeature.timeLineSetting['background'],
          marginTop: data.customFeature.timeLineSetting['margin-top']
        }}>
        {data.customFeature.timeLineSetting.content.map((item, index) => {
          return <React.Fragment key={index}>
            <div data-type={index}
              style={{
                fontWeight: data.status == index ? 600 : '',
                color: data.status == index ? data.customFeature.timeLineSetting['underline-color'] : ''
              }}>{item.name}
              {data.status == index &&
                <span className='under-line'
                  style={{
                    background: data.customFeature.timeLineSetting['underline-color'],
                    height: data.customFeature.timeLineSetting['underline-height']
                  }}>
                </span>
              }
            </div>
          </React.Fragment>
        })}
      </div>
    }

    // 时间轴2
    const $timeLineTwo = () => {
      return <div className="time-line-box"
        onClick={this.getTimeLineGoods}
        data-compindex={this.props.index}
        style={{
          background: data.customFeature.timeLineSetting['background'],
          marginTop: data.customFeature.timeLineSetting['margin-top']
        }}>
        {data.customFeature.timeLineSetting.content.map((item, index) => {
          return <React.Fragment key={index}>
            {item.show &&
              <div data-type={index} className={data.status == index ? 'selected' : ''}>
                <span data-type={index}
                  style={{ background: data.status == index ? data.customFeature.timeLineSetting['slected-color'] : null }}>{item.name}</span>
              </div>
            }
          </React.Fragment>
        })}
      </div>
    }

    // 社区活动商品列表
    const $goodsList = () => {
      return <ScrollView className={`scroll-ele ${data.type}`}
        scroll-y="true"
        bindscrolltolower={this.communityGoodsScrollFunc}
        style={{ height: data.customFeature.height }}
        bindanimationend="animationEnd"
        data-compindex={this.props.index}
        data-type={data.type}>
        {/* 滚动内容区 */}
        {data.communityGoodsDat && data.communityGoodsData.map((item) => {
          return <div className="community-goods-item"
            key={item.id}
            data-leader-token={data.leaderInfo && data.leaderInfo.user_token}
            data-goods-id={item.id}
            onClick={this.toCommunityGoodsDetail}
            data-group-id={item.group_id}
            style={{
              marginTop: data.customFeature.margin,
              height: data.customFeature.goodsList['height']
            }}>
            <div className='community-goods-image' style={{ width: data.customFeature.imgWidth, height: data.customFeature.imgHeight }}>
              <img src={item.cover} />
              {item.form_data.corner_mark > 0 && <img className="goods-subscript" src={item.form_data.corner_url} />}
              {item.dis_group_status == 2 && <img className='group-end' src="http://cdn.jisuapp.cn/static/webapp/images/promotion/group-end.png" />}
              {item.stock == 0 && <img className='group-no-stock' src="http://cdn.jisuapp.cn/static/webapp/images/promotion/group-no-stock.png" />}
            </div >
            <div className='item-content-box'>
              <div className='community-good-title' style={{ fontSize: data.customFeature.goodsList['font-size'] }}>{item.title}</div>
              {(item.dis_group_status == 2 || item.stock == 0) &&
                <div>
                  <div className='end-progress-bar-box'><span className='ico-moon icon-community-group-fire'></span>已售{item.sales}件</div>
                  <span className='community-stock'>剩余{stockChangeModule.stockChange(item.stock)}件</span>
                </div>
              }
              {item.dis_group_status == 1 &&
                <div>
                  <div className='progress-bar-box'><span className='ico-moon icon-community-group-fire'></span><span>已售{item.sales}件</span></div>
                  <span className='community-stock'>剩余{stockChangeModule.stockChange(item.stock)}件</span>
                </div>
              }
              {item.dis_group_status == 3 || item.dis_group_status == 4 || item.dis_group_status == 5 &&
                <div>
                  <div className='unstart-progress-bar-box'><span className='ico-moon icon-about-start'></span>即将开始</div>
                  <span className='community-stock'>仅剩{stockChangeModule.stockChange(item.stock)}件</span>
                </div>
              }
              <div className={`community-good-price ${(item.dis_group_status == 2 || item.stock == 0) ? 'end-pirce' : ''}`}>
                <span className="community-price-icon">¥</span>
                {item.form_data.max_price || item.price}
                {item.virtual_price != 0 && <span className='community-virtual-price'>¥{item.form_data.virtual_max_price || item.virtual_price}</span>}
              </div>
              {(item.dis_group_status == 1 && item.stock != 0) &&
                <div className='add-community-cart ico-moon icon-community-group-goods-cart'
                  onClick={this.addCommunityCart}
                  data-compindex={this.props.index}
                  data-id={item.id}>
                </div>
              }
            </div>
          </div>
        })}
        {/* 加载loading */}
        {data.loading && <RequestStatus is="requestLoading" />}
        {/* 加载没有数据 */}
        {data.is_more == 0 && data.communityGoodsData.length == 0 && <RequestStatus is="requestNone" data={{ data: "暂无活动商品~" }} />}
        {/* 加载失败 */}
        {data.loadingFail && <RequestStatus is="requestFail" data={{ refreshEvent: 'communityGoodsScrollFunc', compindex: this.props.index }} />}
        {/* 加载完所有数据 */}
        {data.is_more == 0 && data.communityGoodsData.length > 0 && data.customFeature.isShowFinishText && <RequestStatus is="requestAll" />}
        {/* 点击加载按钮 */}
        {data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && !!+data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
          <LoadingBtn customFeature={data.customFeature} data-compindex={this.props.index} onClick={this.communityGoodsScrollFunc} />
        }
      </ScrollView>
    }

    // 加入购物车
    const $shoppingCart = () => {
      return <div className="goods-detail-dialog" hidden={!data.showGoodsDetail}>
        <div className="goods-detail-contain">
          <div className="ico-moon icon-closes" onClick={this.hideGoodsDialog} data-compindex={this.props.index}></div>
          <div className="goods-detail-header">
            <img className="community-goods-cover" src={(data.selectGoodsModelInfo && data.selectGoodsModelInfo.imgurl) || (data.goodsDetail && data.goodsDetail.cover)} />
            <div className="select-goods-info">
              <div className="community-goods-price">
                <span>¥{data.selectGoodsModelInfo && data.selectGoodsModelInfo.price}</span>
              </div>
              <div className="community-goods-stock">库存{data.selectGoodsModelInfo && data.selectGoodsModelInfo.stock}</div>
              {data.selectGoodsModelInfo && data.selectGoodsModelInfo.models_text &&
                <div className="select-model">已选：{data.selectGoodsModelInfo.models_text}</div>
              }
            </div>
          </div>
          <div className="goods-detail-content">
            <div className="goods-dialog-content" hidden={!(data.goodsDetail && data.goodsDetail.model.length)}>
              {data.goodsDetail && data.goodsDetail.model.map((model, modelIndex) => {
                return <div className="goods-model" key={modelIndex}>
                  <div className="model-title">{model.name}</div>
                  <div className="sub-model">
                    {model.subModelName((subModelName, submodelIndex) => {
                      return <text
                        key={submodelIndex}
                        data-compindex={this.props.index}
                        data-model-index={modelIndex}
                        data-submodel-index={submodelIndex}
                        className={`subModel ${data.selectGoodsModelInfo.models[modelIndex] == model.subModelId[submodelIndex] ? 'select' : ''}`}
                        data-submodel-id={model.subModelId[submodelIndex]} onClick={this.selectGoodsSubModel}>{subModelName}</text>
                    })}
                  </div>
                </div>
              })}
            </div>
          </div>
          <div className="goods-num-contain">
            <span className="goods-num-title">购买数量：</span>
            <div className="good-number-box pull-right">
            </div>
          </div>
          <div className="goods-shopping-bottom">
            <div className="add-shoppingcart" onClick={this.sureAddToShoppingCart} data-compindex={this.props.index}>加入购物车</div>
          </div>
        </div>
      </div>
    }

    return (
      <div className="custom-component community-goods-list">
        <div className="element community-goods-list" style={styleObj}>
          {/* 搜索 */}
          {data.customFeature.showSearch && $searchWrap()}
          {/* 顶部内容 */}
          {data.customFeature.showGroup && $headWrap()}
          {/* 时间轴1 */}
          {data.customFeature.timeLineSetting.timeLineStyle == 1 && data.customFeature.showTimeline && $timeLineOne()}
          {/* 时间轴2 */}
          {data.customFeature.timeLineSetting.timeLineStyle == 2 && data.customFeature.showTimeline && $timeLineTwo()}
          {/* 社区活动商品列表 */}
          {$goodsList()}
          {/* 加入购物车 */}
          {$shoppingCart()}
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/custom-component/community-goods-list-custom-component/CommunityGoodsListCustomComponent.jsx